// test1346
(1346 && 0);
